<template>
  <div>
    <v-checkbox @change="changeDeleteAttachments = !changeDeleteAttachments" color="primary lighten-2"
                label="Permitir que el club borre adjuntos" v-model="requerimiento.canModifyAttachments"></v-checkbox>
    <v-data-table :items="requerimiento.adjuntos" hide-actions hide-headers v-if="requerimiento.adjuntos.length"
                  no-data-text="No hay datos disponibles">
      <template slot="items" slot-scope="props">
        <tr class="row-element" :key="props.item.asset.id">
          <td><a :href="props.item.asset.url" target="_blank">{{ props.item.asset.name }}</a></td>
          <td>{{ props.item.uploadDate }}</td>
          <td class="text-xs-left">{{ props.item.asset.description }}</td>
          <td class="text-xs-right">
            <v-flex mt-2 pt-2>
              <div v-if="impactsRepo">
                <v-switch @change="getModifiedRepo(props.item)" v-model="props.item.inRepo"
                          label="Impacta en el repositorio" color="primary lighten-2"></v-switch>
              </div>
            </v-flex>
          </td>
          <td class="text-xs-right">
            <v-flex mt-2 pt-2>
              <div v-if="props.item.canConsolidate">
                <v-switch @change="getModifiedConsolidate(props.item)" v-model="props.item.consolidate"
                          label="A Consolidar" color="primary lighten-2"></v-switch>
              </div>
            </v-flex>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    requerimiento: Object,
    impactsRepo: Boolean
  },

  data () {
    return {
      changes: {},
      changeDeleteAttachments: false
    }
  },

  methods: {
    isValid () {
      return true
    },
    isModified () {
      for (let pkAdjunto in this.changes) {
        if (this.isModifiedAttachment(this.changes[pkAdjunto])) {
          return true
        }
      }
      return this.changeDeleteAttachments
    },
    hasAddedFiles () {
      return false
    },
    hasRemovedFiles () {
      return false
    },
    getAddedFiles () {
      return []
    },
    getRemovedFiles () {
      return []
    },
    cleanAddedFiles () {},
    cleanRemovedFiles () {},
    cleanModifiedFiles () {
      this.changes = {}
      this.changeDeleteAttachments = false
    },
    startLoading () {},
    finishLoading () {},
    getModifiedRepo (adjunto) {
      if (!this.changes.hasOwnProperty(adjunto.pk)) {
        this.$set(this.changes, adjunto.pk, { pk: adjunto.pk, inRepo: adjunto.inRepo })
      } else if (!this.changes[adjunto.pk].hasOwnProperty('inRepo')) {
        this.$set(this.changes, adjunto.pk, { pk: adjunto.pk, inRepo: adjunto.inRepo, consolidate: this.changes[adjunto.pk].consolidate })
      }
    },
    getModifiedConsolidate (adjunto) {
      if (!this.changes.hasOwnProperty(adjunto.pk)) {
        this.$set(this.changes, adjunto.pk, { pk: adjunto.pk, consolidate: adjunto.consolidate })
      } else if (!this.changes[adjunto.pk].hasOwnProperty('consolidate')) {
        this.$set(this.changes, adjunto.pk, { pk: adjunto.pk, inRepo: this.changes[adjunto.pk].inRepo, consolidate: adjunto.consolidate })
      }
    },
    getAttachment (pk) {
      return this.requerimiento.adjuntos.find((a) => a.pk === pk)
    },
    isModifiedAttachment (adjunto) {
      let attachment = this.getAttachment(adjunto.pk)
      return adjunto.inRepo === attachment.inRepo || adjunto.consolidate === attachment.consolidate
    },
    getModifiedFiles () {
      let result = []
      for (let pkAdjunto in this.changes) {
        let originalAdjunto = this.changes[pkAdjunto]
        if (this.isModifiedAttachment(originalAdjunto)) {
          let adjunto = this.getAttachment(originalAdjunto.pk)
          result.push({ adjunto: adjunto.pk, inRepo: adjunto.inRepo, consolidate: adjunto.consolidate })
        }
      }
      return result
    }
  }
}
</script>

<style scoped>
a {
  color: #1787c9;
}
.row-element {
  background-color: #f0f0f2;
}
</style>
